<template>
  <Spin fix>
    <Icon
      type="ios-loading"
      size="18"
      class="spin-icon-load"
    />
    <div>Loading</div>
  </Spin>
</template>
<script>
export default {
  name: 'Loading'
}
</script>
<style scoped>
   .spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
  }
</style>
